import React, { Component } from 'react'
import ErrorTexts from "../components/Translation/ErrorTexts";

const AppContext = React.createContext();

class GlobalContextProvider extends Component {

    static defaultApiErrorMsgText = 'The server encountered an unexpected condition which prevented it from fulfilling the request';

    // Context state
    state = {
        user: {},

        processStep: null,

        error: {},
        hasError: false,
    };

    setUser = user => {
        this.setState(prevState => ({ user }))
    };

    setProcessStep = processStep => {
        this.setState(prevState => ({ processStep }))
    };

    setError = error => {
        let error_obj;

        if (error.message.exception !== undefined) { // PHP exception occurred
            error_obj = {
                message: error.message.message,
                error_type: 'APP_EXCEPTION',
            };

        } else if (error.message.error_code !== undefined) { // API exception occurred
            error_obj = {
                message: error.message.message,
                error_code: error.message.error_code,
                error_type: error.message.error_type,
                code: error.message.code,
                ref_no: error.message.ref_no,
            };
        }

        // Set default error message
        if (error_obj.message === '' || error_obj.message === GlobalContextProvider.defaultApiErrorMsgText) {
            error_obj.message = ErrorTexts.lt.translation.default_error_text;
        }

        if (error_obj.error_code === "TOKEN_NOT_EXISTS") {
            error_obj.message = ErrorTexts.lt.translation.error_texts.TOKEN_NOT_EXISTS;
        }

        this.setState({
            error: error_obj,
            hasError: true,
        });

        this.scrollToErrorAlertRef();
    };

    clearError = () => {
        this.setState({
            error: {},
            hasError: false,
        })
    };

    scrollToErrorAlertRef = () => {
        $('html, body').animate({ scrollTop: $('#error-alert').parent('div').offset().top }, 500);
        let elems = [];
        let obj = {};
        let errorElements = document.querySelectorAll('[id=error-alert]');
        Array.from(errorElements).forEach(v => v.getAttribute('class') ? elems.push(v) : null);
        elems.forEach(v => !obj[v.getAttribute('class')] ? obj[v.getAttribute('class')] = 1 :     obj[v.getAttribute('class')]++);
        Object.keys(obj).forEach(function(v) {
            var elements = document.getElementsByClassName(v);
            if (obj[v] > 1) {
                Array.from(elements).forEach(v => v.hidden = true);
                elements[1].hidden = false;
            }
        });
      };

    render() {
        const { children } = this.props;

        const { user, processStep, error, hasError } = this.state;

        const { setUser, setProcessStep } = this;
        const { setError, setErrorAlertRef, clearError } = this;

        return (
            <AppContext.Provider
                value={{
                    // User
                    user,
                    setUser,

                    // Process
                    processStep,
                    setProcessStep,

                    // Global errors
                    error,
                    hasError,
                    setError,
                    clearError,
                }}
            >
                {children}
            </AppContext.Provider>
        )
    }
}

export default AppContext;

export {GlobalContextProvider}
